import { useCallback } from 'react';
import { trackEvent } from 'helpers/analytics';

/** Segment property `feature_name` (after decamelize) for known capability slugs */
const PAYWALL_FEATURE_ANALYTICS_LABEL = {
  people_finder: 'People Finder',
};

export const useUpsellTracking = () => {
  const trackPaywallShown = useCallback((featureKey, extra = {}) => {
    const label = PAYWALL_FEATURE_ANALYTICS_LABEL[featureKey] ?? featureKey;
    trackEvent('upsell:paywall_shown', { featureName: label, ...extra });
  }, []);

  const trackDemoClick = useCallback((featureKey, extra = {}) => {
    const label = PAYWALL_FEATURE_ANALYTICS_LABEL[featureKey] ?? featureKey;
    trackEvent('upsell:demo_click', { featureName: label, ...extra });
  }, []);

  return { trackPaywallShown, trackDemoClick };
};
